import SendReminderButton from './SendReminderButton.component';

export default SendReminderButton;
